import { format } from 'date-fns';
import Link from 'next/link';

import { BlogT } from '~/@customTypes/blog.type';

type Props = {
  posts: Array<BlogT>;
};

export default function SimpleBlog({ posts }: Props) {
  return (
    <div className='relative bg-white pt-8 pb-20 px-4 sm:px-6 lg:pb-28 lg:px-8'>
      <div className='relative max-w-7xl mx-auto'>
        <div className='mt-12 max-w-lg mx-auto grid gap-5 lg:grid-cols-3 lg:max-w-none'>
          {posts.map((post) => (
            <Link key={post.id} href={`/blogs/${post.url_key}`}>
              <a className='block mt-2'>
                <div className='flex flex-col rounded-lg shadow-lg overflow-hidden border border-white hover:border-green-300'>
                  <div className='flex-1 bg-white p-6 flex flex-col justify-between'>
                    <div className='flex-1'>
                      <p className='text-xl font-semibold text-gray-900'>{post.page_title}</p>
                      <p className='mt-3 text-base text-gray-500'>{post.meta_description}</p>
                    </div>
                    <div className='mt-6 flex items-center'>
                      <div className='ml-3'>
                        <div className='flex space-x-1 text-sm text-gray-500'>
                          <time dateTime={post.updated_at}>{format(new Date(post.updated_at), 'yyyy-MM-dd')}</time>
                          <span aria-hidden='true'>&middot;</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
